import { render, staticRenderFns } from "./LSKastenLayer.vue?vue&type=template&id=63e6097a&"
import script from "./LSKastenLayer.vue?vue&type=script&lang=js&"
export * from "./LSKastenLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports